<template>
  <div class="applications">
    <MainHeader
        class="applications__header"
        :title="'Заявки'"
        :number="total"
        :isDropMenu="false"
        :btnText="permission?.includes('bids.control') ? 'Добавить заявку' : false"
        @btnClick="onApplicationAdd"
    />


    <div class="applications__row">
      <VSegmentedControlQuery
          :items="filteringOptions"
          :modelValue="activeFilter"
          class="applications__segmented-control"
      />

      <VDefaultInput
          v-model="search"
          @update:modelValue="() => {}"
          placeholder="Поиск"
          class="applications__search"
      >
        <template #iconLeft>
          <img src="@/assets/images/icons/search.svg" alt="search" />
        </template>
        <template #iconRight>
          <div
              class="applications__search-clear"
              v-if="search"
              @click="search = ''"
          >
            <img src="@/assets/images/icons/x.svg" alt="search" />
          </div>
        </template>
      </VDefaultInput>
    </div>

    <div class="applications__content-wrapper">
      <ApplicationsSidebar
          v-if="!skeletonFilter"
          class="applications__sidebar"
          title="Подразделение"
          subtitle="Заявка"
          :data="itemsList"
          :filterOptions="filterOptions"
          :role="role"
          v-model="sidebarFilters"
      />
      <VSkeleton style="width: 832px" variants="FILTER" v-if="skeletonFilter"/>

      <div v-if="!itemsList && skeletonHeader">
        <VSkeleton v-if="skeletonHeader" style="margin-left: 32px" variants="HEADER"/>
        <VSkeleton v-if="skeletonContent" style="margin-left: 32px" variants="CONTENT"/>
      </div>

      <div class="applications__content" v-if="itemsList">
        <HeaderSort
            v-if="!skeletonHeader"
            class="applications__header-sort"
            :modelValue="sortOrder"
            :scheme="headerScheme"
            no-sort-btn
            @update:modelValue="onSortOrderUpdate"
        />
        <VSkeleton v-if="skeletonHeader" style="margin-left: 32px" variants="HEADER" />
        <div class="applications__cards-wrapper" v-if="itemsList">
          <VSkeleton style="margin-left: 32px; margin-top:12px" variants="CONTENT" v-if="skeletonContent"/>
          <div class="applications__cards">
            <a class="applications__card" :href="'/applications/' + item.id" v-for="item in itemsList">
              <ListCard
                  v-if="!skeletonContent"
                  ref="listCardElement"
                  :key="item.id"
                  :cardData="item"
                  :scheme="candidatesListScheme"
                  @openChat="() => {}"
              >
                <template #field(name)="{ cardData }">
                  <div class="card-item__column">
                    <div class="card-item__name">{{ cardData?.data?.title }}</div>
                    <div
                        v-if="cardData?.data?.has_duplicate"
                        class="item-name__dublicate"
                    >
                      Найден дубликат
                    </div>
                  </div>
                </template>
                <template #field(subdivision)="{ cardData }">
                  <div class="card-item__column">
                    <div>{{ cardData?.data?.division_name }}</div>
                  </div>
                </template>
                <template #field(location)="{ cardData }">
                  <div class="card-item__column">
                    <div>{{ cardData?.data?.place_of_work }}</div>
                  </div>
                </template>
                <template #field(legalEntity)="{ cardData }">
                  <div class="card-item__column">
                    <div>{{ cardData?.data?.legal_entity_name }}</div>
                  </div>
                </template>
                <template #field(status)="{ cardData }">
                  <div class="card-item__column" v-if="cardData.data?.status">
                    <StatusTag
                        :status="{
                      label:cardData.data?.status,
                      name: cardData.data?.status,
                    }"
                    />
                    <div class="card-item__status-text">
                      {{ cardData.data?.hiring?.fact }} / {{ cardData.data?.hiring?.plan }}
                    </div>
                  </div>
                </template>
                <template #field(priority)="{ cardData }">
                  <div class="flex">
                    <div class="status" :class="getColorCircle(cardData.data.priority)"></div>
                    <div>{{cardData.data.priority}}</div>
                  </div>
                </template>

              </ListCard>
            </a>
          </div>
          <div v-if="!responsesList?.data?.items && skeletonHeader">
            <VSkeleton v-if="skeletonHeader" style="margin-left: 32px" variants="HEADER"/>
            <VSkeleton v-if="skeletonContent" style="margin-left: 32px" variants="CONTENT"/>
          </div>
        </div>
        <div class="applications__no-content" v-if="!skeletonContent && !itemsList?.length">
          <div class="applications__no-content-wrapper">
            <p class="applications__no-content-title">Список заявок пуст</p>
            <p class="applications__no-content-description">
              По выбранному фильтру ничего не найдено
            </p>
          </div>
        </div>

        <div class="applications__no-content" v-if="!itemsList">
          <VNoContent
              v-if="!applicationFilters.search"
              :title="textNoContent"
              description="По выбранному фильтру ничего не найдено"
          />
          <VNoContent
              v-if="applicationFilters.search"
              title="Ничего не найдено"
              description="Проверьте пожалуйста, правильно ли вы написали название"
          />
        </div>
      </div>

    </div>
  </div>
</template>
<script setup>
import MainHeader from "@/components/MainHeader/index.vue";
import VSegmentedControlQuery from "@/components/UI/VSegmentedControlQuery/index.vue";
import {computed, onMounted, ref, watch} from "vue";
import ApplicationsSidebar from "@/components/Application/ApplicationsSidebar.vue";
import VSkeleton from "@/components/UI/VSkeleton/index.vue";
import { useStore } from "vuex";
import HeaderSort from "@/components/Common/HeaderSort/index.vue";
import ListCard from "@/components/Common/ListCard/index.vue";
import StatusTag from "@/components/Common/StatusTag/index.vue";
import {useRoute, useRouter} from "vue-router";
import applications from "@/api/applications";
import legal from "@/api/legal";
import divisions from "@/api/divisions";
const search = ref("")
const activeFilter = ref("active")
const store = useStore();
const role = store.getters["auth/role"];
const permission = localStorage.getItem("profileInfo")
const filteringOptions = computed(() => {
  let options = []
  if(permission?.includes('bids.control')) {
    options.push({
      id: "active",
      label: "Активные",
    })
  }
  if(permission?.includes('bids.approve')) {
    options.push({
      id: "awaiting_approve",
      label: "На согласование",
    })
  }
  if(permission?.includes('bids.take-to-work')) {
    options.push({
      id: "new",
      label: "Новые",
    })
    options.push({
      id: "in_work",
      label: "В работе",
    })
  }
  if(permission?.includes('bids.control')) {
    options.push({
      id: "closed",
      label: "Закрытые",
    })
  }
  return options
})

const skeletonFilter = ref(false)
const skeletonContent = ref(false)
const skeletonHeader = ref(false)
const router = useRouter()
const route = useRoute();

const itemsList = ref([]);
const total = ref(0);
const sidebarFilters = ref([])
const filterOptions = ref({
  status: [
    {label: 'Согласование', id: 'Согласование'},
    {label: 'Согласовано', id: 'Согласовано'},
    {label: 'Не согласовано', id: 'Не согласовано'},
    {label: 'В работе', id: 'В работе'},
    {label: 'Выполнено', id: 'Выполнено'},
    {label: 'Отменено', id: 'Отменено'},
  ],
  priority: [
    {label: 'Низкий', id: 'Низкий'},
    {label: 'Средний', id: 'Средний'},
    {label: 'Высокий', id: 'Высокий'},
  ],
  legalEntity: [],
  division: []
});


const sortOrder = ref({});
const headerScheme = [
  {
    label: "Название",
    value: "name",
    sortable: false,
    width: "150",
  },
  {
    label: "Подразделение",
    value: "subdivision",
    sortable: false,
    width: "127",
  },
  {
    label: "Локация",
    value: "location",
    sortable: false,
    width: "75",
  },
  {
    label: "Юр. лицо",
    value: "legalEntity",
    sortable: false,
    width: "95",
  },
  {
    label: "Статус",
    value: "status",
    sortable: false,
    width: "110",
  },
  {
    label: "Приоритет",
    value: "priority",
    sortable: false,
    width: "85",
  },
];

const candidatesListScheme = {
  name: {
    key: "name",
    type: "string",
    class: "text",
    width: "150",
  },
  age: {
    key: "subdivision",
    type: "string",
    class: "text",
    width: "127",
  },
  status: {
    key: "location",
    type: "split_horizontal",
    class: "text",
    width: "75",
    additionalKey: "days",
  },
  specialities: {
    key: "legalEntity",
    type: "string",
    class: "text",
    width: "95",
  },
  work_experience: {
    key: "status",
    type: "string",
    class: "text",
    width: "110",
  },
  residence: {
    key: "priority",
    type: "string",
    class: "text",
    width: "85",
  },
};
const getColorCircle = (priority) => {
  if (priority === 'Низкий') {
    return 'color_gray'
  }
  if (priority === 'Высокий') {
    return 'color_red'
  }
  return 'color_blue'
}

const textNoContent = ref('')
const onSortOrderUpdate = (val) => {
  applicationFilters.value.sort = val;
};

const getFieldName = (desc, name) => {
  if(desc && name) return desc + ', ' + name
  if(desc) return desc
  return name
}
const onApplicationAdd = () => {
  router.push("/applications/new");
};

const getData = async () => {
  skeletonContent.value = true
  skeletonHeader.value = true
  let query
  if (route.query?.filters) {
    query = {
      tab: route.query.tabs,
      search: route.query.search,
      "created_at[to]": JSON.parse(route.query?.filters)?.created_at_to_query,
      legal_entity_id: JSON.parse(route.query?.filters)?.legal_entity_id,
      division_id: JSON.parse(route.query?.filters)?.division_id,
      speciality_id: JSON.parse(route.query?.filters)?.speciality_id,
      status: JSON.parse(route.query?.filters)?.status,
      priority: JSON.parse(route.query?.filters)?.priority,
      place_of_work: JSON.parse(route.query?.filters)?.place_of_work,
      specialities: JSON.parse(route.query?.filters)?.specialities,
    }
  } else {
    query = {
      tab: route.query.tabs,
      search: route.query.search,
    }
  }

  const res = await applications.getApplicationsList(query)
  itemsList.value = res?.data
  total.value = res?.meta?.total
  skeletonContent.value = false
  skeletonHeader.value = false
}

function flattenArrayReduce(arr) {
  return arr.reduce((acc, item) => {
    acc.push(item);
    if (item.children && item.children.length > 0) {
      acc = acc.concat(flattenArrayReduce(item.children));
    }
    return acc;
  }, []);
}

onMounted(async () => {
  search.value = route.query?.search || ''
  if(route.query?.tabs) {
    await getData()
  }
  filterOptions.value.legalEntity = await legal.getLegal()
  filterOptions.value.legalEntity = filterOptions.value.legalEntity?.data?.map((option, index) => ({
    id: option.id,
    label: option.short_name,
  }))
  const data = await divisions.getDivisions()
  filterOptions.value.division = flattenArrayReduce(data?.data)
  filterOptions.value.division = filterOptions.value.division?.map(item => {
    return {
      id: item.id,
      label: item.name,
    }
  })
})


watch(() => route.query, async () => {
  if(route.query?.tabs) {
    await getData()
  }
}, {deep: true})

watch(search, (newValue) => {
  router.replace({query: {...route.query, search: newValue}});
})
</script>
<style scoped lang="scss">
.applications {
  &__header {
    margin-top: 32px;
    margin-bottom: 32px;

  }

  &__segmented-control {
    width: 827px;
    margin-right: 32px;
    &::v-deep(.v-filtration__filter) {
      min-width: 164px;
      margin-left: 0;
    }
    :deep(.v-filtration__filter_active .v-filtration__label) {
      font-weight: 632;
    }
  }

  &__content-wrapper {
    margin-top: 32px;
    display: flex;
  }

  &__row {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
  }

  &__search {
    width: 448px;

    &::v-deep(.companies__search-clear) {
      height: 20px !important;
    }

    &::v-deep(.v-input__input) {
      &::placeholder {
        color: $dark-blue;
        opacity: 1;
      }
    }

    :deep(.v-input__input::placeholder) {
      color: #566a83 !important;
    }
  }

  &__content {
    width: 832px;
  }

  &__cards {
    margin-left: 32px;
    width: 100%;
    height: calc(100% - 206px);
    margin-top: 12px;
    display: flex;
    flex-direction: column;
  }

  &__card {
    width: 100%;
    text-decoration: none;

    &:not(:first-child) {
      margin-top: 8px;
    }
  }

  &__no-content {
    margin-left: 32px;
    width: 100%;
    height: calc(
        100vh - 56px - 32px - 34px - 24px - 48px - 32px - 40px - 57px - 57px
    );
    max-height: calc(475px - 40px);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__no-content-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 352px;
    font-size: 24px;
    font-weight: 600;
    line-height: 29.05px;
    text-align: center;
    color: $dark;
  }
  &__no-content-title {
    margin-bottom: 12px;
    font-size: 24px;
    font-weight: 600;
    line-height: 29.05px;
    text-align: center;
    color: $dark;
  }
  &__no-content-description {
    font-size: 16px;
    font-weight: 400;
    line-height: 19.36px;
    text-align: center;
    color: $dark;
  }

  &__pagination {
    position: relative;
    width: 100%;
    height: 48px;
    margin-top: 32px;
    display: flex;
    justify-content: center;
  }

  &__pagination-btn {
    width: 156px;
    padding: 0 10px;
    border-radius: 8px;

    &:active {
      background-color: #0d5fcb80 !important;
      color: $blue !important;
    }
  }

  &__pagination-pag {
    position: absolute;
    top: 0;
    right: 0;
  }

  &__approval-history-modal {
    &::v-deep(.modal__body) {
      width: 626px;
    }
  }

  &__content-wrapper {
    margin-top: 32px;
    display: flex;
  }

  &__sidebar {
    width: 256px;
  }

  &__header-sort {
    margin-left: 32px;
  }

  &__file-import {
    visibility: hidden;
    display: inline-block;
    outline: none;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    appearance: none;
    cursor: pointer;
  }
}

.card-item {
  &__name {
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    vertical-align: middle;

  }

  &__column {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: fit-content;
    & > div {
      flex: 0 0 auto;
    }
  }
  &__status-text {
    font-size: 13px;
    font-weight: 400;
    line-height: 15.73px;
    text-align: left;
    color: $gray;
  }
  &__tags {
    padding: 2px 2px;
    border: 1px solid #566a83;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    line-height: 14.52px;
    text-align: left;
    line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: fit-content;
    max-width: 100%;
  }
  &__specialities {
    line-clamp: 1;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__residence {
    display: -webkit-box;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.item-name {
  &__dublicate {
    padding: 2px 8px;
    border-radius: 4px;
    color: $dark;
    background-color: $light-gray-1;
    font-size: 11px;
    font-weight: 400;
    line-height: 13.31px;
    text-align: left;
  }
}

.color-primary {
  color: $primary-main;
}


.color {
  &_blue {
    background-color: $primary-main!important;;
  }
  &_red  {
    background-color: $red-main!important;
  }
  &_gray {
    background-color: $grey-pressed!important;;
  }
  &_none {
    background-color: transparent;
  }
}

.status {
  content: '';
  //position: absolute;
  //top: 29px;
  //left: 166px;
  //width: 10px;
  //height: 10px;
  align-self: center;
  margin-right: 8px;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  background-color: var(--color);
}
</style>